import * as React from 'react';
import { useIntl } from '@/intl';
import { ListItem, RadioGroup, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import type { RouteInfo, Route } from '../../../domain/prices/transports/types';

const PriceWrapper = styled(SpaceBetween)`
  text-align: end;
`;

interface CardControlProps {
  id: string;
  isSelected: boolean;
  onClick: (id: string) => void;
}

export const CardControl = ({ id, onClick, isSelected }: CardControlProps) => {
  const onClickHandler = () => {
    onClick(id);
  };

  return (
    <ListItem.Control>
      <RadioGroup.Item value={id} checked={isSelected} onClick={onClickHandler} />
    </ListItem.Control>
  );
};

export const CardTrailing = ({ price }: { price: number }) => {
  const intl = useIntl();

  return (
    <ListItem.Trailing>
      <PriceWrapper direction="y" spacing={tk('spacing_2xs')}>
        <Typography $variant="label">{intl.formatCurrency(price, true)}</Typography>
        <Typography $variant="body-xs">
          {intl.formatMessage({ id: 'prices_transport_selector_price-per-person_abbreviation' })}
        </Typography>
      </PriceWrapper>
    </ListItem.Trailing>
  );
};

export const TravelRoute = ({ from, to }: Route) => (
  <ListItem.Description>
    {`${from.name} (${from.code})`} ········· {`${to.name} (${to.code})`}
  </ListItem.Description>
);

export interface CardProps extends RouteInfo {
  setSelected?: (id: string) => void;
  isSelected: boolean;
}
